(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-section-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const previous = event.target.closest('[data-halte-review-prev]');
    const next = event.target.closest('[data-halte-review-next]');

    if (!previous && !next) return;

    const slider = event.target.closest('[data-halte-review-slider]');
    if (!slider) return;

    const track = slider.querySelector('.halte-proof-strip__track');
    if (!track) return;

    const direction = next ? 1 : -1;
    track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

})();
